var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticStyle: { display: "inline-block", "vertical-align": "top" } },
      [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valueData,
                expression: "valueData"
              }
            ],
            ref: "selectize-field",
            staticClass: "form-control input-xsmall",
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.valueData = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          _vm._l(_vm.options, function(option, index) {
            return _c("option", { key: index, domProps: { value: option } }, [
              _vm._v(_vm._s(option))
            ])
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn red action-reset-select",
        staticStyle: { display: "inline-block" },
        on: { click: _vm.resetClick }
      },
      [_c("i", { staticClass: "fa fa-times" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }